import api from '../../utils/api';

export default {
  fetch: (query) => api.makeEndpoint('get', `catalog/categories${query}`),
};
